import { CheckCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import type { PlatformConnectionRow, PlatformType } from '@/features/platform/types'

type Props = {
  open: boolean
  row: PlatformConnectionRow | null
  isPending: boolean
  onClose: () => void
  onRun: (payload: { platformId: string; type: PlatformType }) => Promise<void>
  addToast: (message: string, type: 'success' | 'error' | 'warning' | 'info') => void
}

export function ManualRefreshModal({ open, row, isPending, onClose, onRun, addToast }: Props) {
  const confirmManualRefresh = async () => {
    if (!row) return
    try {
      await onRun({
        platformId: row.id,
        type: row.type,
      })
      addToast('Manual refresh triggered', 'success')
      onClose()
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Unable to run manual refresh'
      addToast(message, 'error')
    }
  }

  return (
    <Modal
      open={open}
      title="Manual refresh"
      okText="Run refresh"
      okButtonProps={{ loading: isPending, icon: <CheckCircleOutlined /> }}
      onOk={() => void confirmManualRefresh()}
      onCancel={onClose}
    >
      <p className="text-sm text-gray-700">
        Are you sure you want to run a manual refresh for <strong>{row?.name}</strong>?
      </p>
    </Modal>
  )
}
